import React from "react";
import {
  // HiXCircle,
  MdSkipNext,
  // MdSkipPrevious,
  // MdExitToApp
} from "react-icons/md";
import { useTranslation } from "react-i18next";

export default function NextZoomPagePartButton(props) {
  const { t } = useTranslation();
  return (
    <>
      <button
        // disabled={props.isLoading}
        className={`button  is-small modal-button`}
        onClick={props.onClickHandler}
        title={t("Next")}
      >
       <span className="has-text-light ">Next</span>
        <span className="icon  has-text-light">
          <MdSkipNext className="fas fa-2x" />
        </span>
      </button>
    </>
  );
}
